import {Handedness, PredictionResult} from "modules/enums";
import {createAction} from "redux-act";

interface IFetchPlayerDetail {
	playerId: number;
	unitId: number;
	pitcherId?: number | null;
}

export const fetchPlayerDetail = createAction<IFetchPlayerDetail>();

interface ISeasonStats {
	season: number;
	hits: number;
	atBats: number;
	avg: number;
	homeRuns: number;
	runsBattedIn: number;
	stolenBases: number;
	onBasePlusSlugging: number;
}

interface IBatterVsPitcher {
	atBats: number;
	hits: number;
	avg: number;
	batterHandedness: Handedness;
	pitcherHandedness: Handedness;
}

interface IUnitActions {
	id: string;
	timestamp: string;
	description: string;
	phase: number;
	phaseQualifier: string;
	balls: number;
	strikes: number;
	outs: number;
	firstBasePlayerId: number | null;
	secondBasePlayerFeedId: number | null;
	thirdBasePlayerFeedId: number | null;
	videoLink: string | null;
}

interface IMatchResults {
	atBats: number | null;
	hits: number | null;
	playerId: number | null;
	result: PredictionResult | null;
	sacFlies: number | null;
	streak: number | null;
}

interface IDetailStats {
	playerFistName: string;
	playerLastName: string;
	numberUserPicks: number;
	rankByTotalSelections: number;
	totalAvgPicks: number;
	percentCorrectUserPicks: number;
	rankByUserPicks: number;
	rankByUserPercentCorrectPicks: number;
}

interface IPlayerDetail {
	seasonsStats: ISeasonStats[];
	unitActions: IUnitActions[];
	lastActions: IUnitActions[];
	batterVsPitcherStats: IBatterVsPitcher;
	matchPlayerResults: IMatchResults;
	personalizedDetailStats: IDetailStats | null;
}

export const fetchPlayerDetailSuccess = createAction<IPlayerDetail>();
export const fetchPlayerDetailFailed = createAction();
